import MenuIcon from "@mui/icons-material/Menu";
import {
    AppBar,
    Button,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Stack,
    Toolbar,
    useScrollTrigger,
} from "@mui/material";
import { styled } from "@mui/system";
import { navigate } from "@reach/router";
import React, { useState } from "react";
import { colors } from "theme";
import { Brand } from "./Brand";

const LinkButton = styled(Button)({
    color: "inherit",
    "&:hover": {
        textDecoration: "underline",
    },
});

const drawerWidth = 200;

export interface HeaderProps {
    translucent?: boolean;
}

export function Header(props: HeaderProps) {
    const { translucent } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
    });
    const [drawerOpen, setDrawerOpen] = useState(false);

    const handleClickToOutputs = () => {
        setDrawerOpen(false);
        navigate("/ios");
    };

    const handleClickToAbout = () => {
        setDrawerOpen(false);
        navigate("/#about");
    };

    const handleClickToLibrary = () => {
        setDrawerOpen(false);
        navigate("/#library");
    };

    const handleClickToPartners = () => {
        setDrawerOpen(false);
        navigate("/#partners");
    };

    const handleClickToContact = () => {
        setDrawerOpen(false);
        navigate("/#contact");
    };

    return (
        <>
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: drawerWidth,
                        boxSizing: "border-box",
                    },
                    display: { md: "none", xs: "block" },
                }}
            >
                <List>
                    <ListItem button onClick={handleClickToAbout}>
                        <ListItemText primary="About" />
                    </ListItem>
                    <ListItem button onClick={handleClickToOutputs}>
                        <ListItemText primary="Outputs" />
                    </ListItem>
                    <ListItem button onClick={handleClickToLibrary}>
                        <ListItemText primary="Library" />
                    </ListItem>
                    <ListItem button onClick={handleClickToPartners}>
                        <ListItemText primary="Partners" />
                    </ListItem>
                    <ListItem button onClick={handleClickToContact}>
                        <ListItemText primary="Contact" />
                    </ListItem>
                </List>
            </Drawer>
            <AppBar
                position={translucent ? "sticky" : "fixed"}
                sx={{
                    backgroundColor:
                        trigger || translucent
                            ? colors.background
                            : "transparent",
                    transition: "all 0.5s",
                    color: "white",
                }}
                elevation={trigger || translucent ? 4 : 0}
            >
                <Toolbar style={{ display: "flex" }}>
                    <div style={{ flexGrow: 1 }}>
                        <Brand />
                    </div>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => setDrawerOpen(true)}
                        edge="end"
                        sx={{ display: { md: "none", xs: "block" } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Stack
                        spacing={2}
                        alignItems="center"
                        direction="row"
                        sx={{ display: { xs: "none", md: "block" } }}
                    >
                        <LinkButton onClick={handleClickToAbout}>
                            About
                        </LinkButton>
                        <LinkButton onClick={handleClickToOutputs}>
                            Outputs
                        </LinkButton>
                        <LinkButton onClick={handleClickToLibrary}>
                            Library
                        </LinkButton>

                        <LinkButton onClick={handleClickToPartners}>
                            Partners
                        </LinkButton>
                        <LinkButton onClick={handleClickToContact}>
                            Contact
                        </LinkButton>
                    </Stack>
                </Toolbar>
            </AppBar>
        </>
    );
}
